import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  paramsSerializer: (params) => {
    return Object.keys(params)
      .map((key) => {
        const value = params[key];

        if (Array.isArray(value)) {
          return value
            .map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
            .join('&');
        } else if (value !== undefined && value !== null) {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }

        return '';
      })
      .filter(Boolean)
      .join('&');
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response?.data?.data,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;

    if (status === 400) {
      // TODO
      console.log('ERROR :: ', data?.message);
    }

    if (status === 401) {
      console.error('Unauthorized - logging out');
      Cookies.remove('admin_token');
      // window.location.href = "/login";
    }

    if (status === 404) {
      console.warn('API not found:', error.config.url);
    }

    if (status >= 500) {
      console.error('Server error:', status);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
